import React from 'react'
import Datetime from 'react-datetime'
import moment from 'moment'
import '../functions/momentSettings'
import {getSelectedCulture} from '../functions/countrySetting'

const DateTimeField = ({field, validate}) => {
  let hasErrors = field.errors.length > 0 ? true : false

  let value = '';
  if (field.value){
    value = moment(field.value);
  }

  return (
    <div className={hasErrors ? 'form-group text-danger' : 'form-group'}>
      <label className="form-control-label">{field.rules.title}</label>
      <Datetime
        locale={getSelectedCulture()}
        dateFormat={true}
        timeFormat={false}
        input={true}
        viewMode={'days'}
        utc={true}
        className={
          hasErrors
            ? 'is-invalid'
            : ''
        }
        onBlur={e => validate(e._d, field)}
        value={value}
        onChange={e => validate(e._d, field)}
      />
      {field.errors.map((error, i) => (
        <div key={i} className="form-text text-danger">
          {error}
        </div>
      ))}
    </div>
  )
}

export default (DateTimeField)
